import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DatePicker from './DatePicker.json';
import Header from './Header.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import MeasurementTable from './MeasurementTable.json';
import Messages from './Messages.json';
import Measurements from './Measurements.json'; //epeople

export default {
  'pt-BR': {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    DatePicker,
    Header,
    UserPreferencesModal,
    MeasurementTable,
    Messages,
    Measurements, //epeople, foi criado o arquivo pt-BR\Measurements.json
  },
};
